import React from 'react';
import VideoCard from '../common/VideoCard.jsx';
import { __ } from '../../Lang.js';

const GuestVideos = ({ videos = [] }) => {

  const locale = document.documentElement.lang || 'en';

  return (
    <section className="section bg-light homepage-guest-videos">
      <h2>{__('New content added weekly')}</h2>
      <p>{__('Keep discovering new keys and awareness on the path of Soul Transcendence')}</p>

      <div className="video-card-grid">
        {videos.map((video, idx) => {
          return (
              <div key={video.uniqid} className="playlist-row__item">
                <VideoCard 
                  video={video}
                />
              </div>
          );
        })}
      </div>
    </section>
  );
};

export default GuestVideos;